import { FormTextField } from "@components";
import { IFocusableForm } from "@type";
import React, { useEffect } from "react";
import { IFreightSchemeModel } from "./FreightForm.types";
import { FormLocationField } from "@components/shared";

interface IConfigSendleProps {
  parentForm: IFocusableForm<Partial<IFreightSchemeModel>>;
}

export const ConfigSendle: React.FC<IConfigSendleProps> = ({ parentForm }) => {
  const apiUrl = parentForm.getValues().ApiUrl;
  useEffect(() => {
    const newValue = "https://api.sendle.com/api";
    if (apiUrl !== newValue) {
      parentForm.setFieldValue("ApiUrl", newValue);
    }
  }, [apiUrl, parentForm]);

  return (
    <>
      <FormTextField
        label="API Url:"
        withAsterisk
        fieldName="ApiUrl"
        parentForm={parentForm}
        disabled
      />

      <FormTextField
        label="UserName:"
        withAsterisk
        fieldName="ApiUserName"
        parentForm={parentForm}
      />

      <FormTextField
        label="Password / Token:"
        withAsterisk
        fieldName="ApiPassword"
        parentForm={parentForm}
      />

      <FormLocationField
        placeholder="Enter Postcode or Suburb"
        label="From location:"
        fieldMap={{
          location: "FromLocation",
          suburb: "FromSuburb",
          postcode: "FromPostcode",
          state: "FromState",
        }}
        parentForm={parentForm}
      />
    </>
  );
};
